import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { AddEditUsersComponent } from 'src/app/components/security/users/widgets/addedituser.component';
import { UserModel } from 'src/app/components/security/users/models/userModel';
import { RestAPIService } from 'src/app/services/restapi.service';
import { environment } from 'src/environments/environment';
import { UserListModel } from '../../models/userListModel';
import * as moment from 'moment';
import { ConfirmDialogComponent } from 'src/app/components/confirmation/confirm-dialog.component';
import { ToastService } from 'src/app/services/toaster.service';
import { LoginResponseModel } from 'src/app/modules/login/models/loginResponseModel';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
  selector: 'app-users',
  templateUrl: './user.component.html'
})
export class UsersComponent {
  public pageSize = 10;
      public currentPage = 0;
      public totalSize = 0;
      @ViewChild(MatPaginator) paginator!: MatPaginator;
      @ViewChild(MatSort) sort!: MatSort;
      userList: UserListModel[] = [];
      sortedUserList: UserListModel[] = [];
      userModel: UserModel = new UserModel();
      dataSource = new MatTableDataSource<UserListModel>();
      isAdvanceSearchFilter: boolean = false;
      filterKey: string = '';
      currentSort!: Sort;
      selectedProductCode!: string;
      selectedOption: string = '';
      currentUserEmail: string = '';
      currentUserIsOwner: boolean = false;

      displayedColumns = ['firstName','lastName','email','role','status','updatedAt', 'action'];
      isWritePermission: boolean = true;
      constructor(public _restAPI: RestAPIService,
        public dialog: MatDialog, private toast: ToastService, private permissionService: PermissionService) {
            this._restAPI.loading  = false;
            let tokenData: LoginResponseModel = new LoginResponseModel();
            const tokenDatajson = localStorage.getItem('token_data');
            if(tokenDatajson) {
                tokenData = JSON.parse(tokenDatajson);
                this.currentUserEmail = tokenData.email ?? '';
            }
            if(!this.permissionService.has('user.write')){
                this.isWritePermission = false;
                this.displayedColumns = this.displayedColumns.filter(col => col !== 'action');
            }
        }

    ngOnInit() {
        if (localStorage["applyUserFilterValue"] === 'true') {
            this.getUserList(localStorage["userFilterValue"]);
        }
        else {
            this.getUserList('');
        }
        localStorage["applyUserFilterValue"] = '';
    }

    onDisplayFilter(e : any) {
        this.isAdvanceSearchFilter = !this.isAdvanceSearchFilter;
        if(e) {
            e.stopPropagation();
        }
    }

    applyFilter(filterValue: string) {
        if (this.dataSource?.paginator) {
            this.dataSource.paginator.pageIndex = 0;
        }
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        localStorage["userFilterValue"] = filterValue;
        this.dataSource.filter = filterValue;
    }

    applyActiveFilter(){
        this.dataSource.data = this.userList;
        if(this.selectedOption === '1'){
            this.dataSource.data = this.dataSource.data.filter(x=>x.isActive === true);
        }
        else if(this.selectedOption === '2'){
            this.dataSource.data = this.dataSource.data.filter(x=>x.isActive === false);
        }
    }

    clearFilter(){
        this.selectedOption = '';
        this.filterKey='';
        this.applyActiveFilter();
        this.applyFilter('');
    }

    openUserDialog(roleModel: UserModel): void {
        const dialogRef = this.dialog.open(AddEditUsersComponent, {
            width:"1024px",
            data:{
                userModel: roleModel,
                isOwner: this.currentUserIsOwner
            } 
        });

        dialogRef.afterClosed().subscribe(result => {
            this.userModel = new UserModel();
            if (result) {
                this.getUserList(localStorage["userFilterValue"]);
            }
            localStorage["applyUserFilterValue"] = '';
        });
    }

    async getUserList(filterValue : any) {
        this._restAPI.loading  = true;
        this._restAPI.get<UserListModel[]>(environment.apiURL + 'api/userrole/userlistwithrole').subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                for(let userObj of data){
                    if(!userObj.updatedOn){
                        userObj.updatedOn = userObj.createdOn;
                    }
                    if(userObj.email === this.currentUserEmail && userObj.role?.toLowerCase() === "owner"){
                        this.currentUserIsOwner = true;
                    }
                }
                this.userList = data;
                this.sortedUserList = this.userList.slice();
                this.totalSize = this.sortedUserList.length;
                this.dataSource.data = data;
                this.dataSource.filter = filterValue;
                this.filterKey = filterValue;
                this.dataSource.sort = this.sort;
                this.dataSource.paginator = this.paginator;
            },
            error: (error) =>{console.error(error); this._restAPI.loading  = false;}
        });
    }

    sortUsers(sort: Sort) {
        if (this.dataSource?.paginator) {
            this.dataSource.paginator.pageIndex = 0;
        }
        this.dataSource.filter = "";
        this.filterKey = "";
        this.currentSort = sort;
        this.pageSize = 10;
        this.currentPage = 0;
        this.sortUserArray(this.userList.slice(), this.currentSort);
        this.dataSource.data = this.sortedUserList;
    }

    onToggleChange(event: MatSlideToggleChange, id: string){
        

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '500px',
            data: {
              message: `Are you sure you want to ${event.checked ? 'active' : 'inactive'} this user?`
            }
          });
      
          dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                console.log('Toggle changed:', event.checked); // true or false

                let postData = {
                    userId: id,
                    isActive: event.checked
                  };

                this._restAPI.loading  = true;  
                this._restAPI.put<string>(environment.apiURL + 'api/usermanagement/activeinactive', postData).subscribe({
                    next: (results) => {
                        this._restAPI.loading  = false;
                        dialogRef.close(true);
                        this.toast.show("User has been updated succussfully");
                    },
                    error: (error) => {console.error(error);this._restAPI.loading  = false;}
                });

              //this.isToggled = event.checked;
              //event.source.checked = this.isToggled;
            }
            else{
                event.source.checked = !event.checked;
            }
          });
    }

    private sortUserArray(roles: UserListModel[], sort: Sort): void {
        if (sort === undefined || !sort.active || sort.direction === '') {
            this.sortedUserList = roles.slice();
            return;
        }

        this.sortedUserList = roles.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'firstName': return compare(a.firstName ?? '', b.firstName ?? '', isAsc);
                case 'lastName': return compare(a.lastName ?? '', b.lastName ?? '', isAsc);
                case 'email': return compare(a.email ?? '', b.email ?? '', isAsc);
                case 'role': return compare(a.role ?? '', b.role ?? '', isAsc);
                case 'status': return compare(a.isActive ?? false, b.isActive ?? false, isAsc);
                case 'updatedAt': return compare(a.updatedOn ?? new Date(-8640000000000000), b.updatedOn ?? new Date(-8640000000000000), isAsc);
                default: return 0;
            }
        });

        const part = this.sortedUserList.slice();
        this.sortedUserList = [];
        for (const user of part) {
            this.sortedUserList.push(user);
        }
    }

    private getDate(date : Date | null){
        if(date){
            return moment.utc(date).local().format('YYYY-MM-DD hh:mm A');
        }
        else{
            return null;
        }
    }
}

function compare(a: number | string | boolean | Date, b: number | string | boolean | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

